<div class="migo-dialog">
  <div class="migo-dialog__content">
    <h6 class="title-6-bold">{{ title }}</h6>
    <p>
      {{ message }}
    </p>
  </div>
  <div class="migo-dialog__actions" mat-dialog-actions>
    <mg-button
      class="w-full"
      [mat-dialog-close]="false"
    >
      {{ cancelText }}
    </mg-button>
    <mg-button
      class="w-full"
      [mat-dialog-close]="true"
    >
      {{ confirmText }}
    </mg-button>
  </div>
</div>
